import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../componentes/Plantilla/Plantilla';

export const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div 
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '160px 24px',
          textAlign: 'center',
          backgroundColor: 'var(--bg-light)',
          minHeight: '60vh'
        }}
      >
        <span 
          style={{
            fontSize: '5rem',
            fontWeight: '800',
            color: 'var(--primary-color)',
            lineHeight: 1,
            marginBottom: '20px'
          }}
        >
          404
        </span>
        <h1 style={{ fontSize: '2rem', marginBottom: '16px', color: 'var(--text-primary)' }}>
          Página No Encontrada
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto 30px auto' }}>
          La ruta que intenta consultar no existe o ha sido trasladada a otra sección. Por favor, regrese al portal principal de SEIMA.
        </p>
        <Link to="/" className="btn btn-primary">
          Regresar al Inicio
        </Link>
      </div>
    </Layout>
  );
};
export default NotFound;
